import { teachurKeys as o } from "../../constants/teachurKeys.js";
const i = async (t, e, c) => {
  const s = o.courses.instructors(e);
  await t.cancelQueries({ queryKey: s });
  const r = t.getQueryData(s);
  return r && t.setQueryData(s, [...r, c]), { previousInstructors: r };
}, n = async (t, e, c) => {
  const s = o.courses.instructors(e);
  await t.cancelQueries({ queryKey: s });
  const r = t.getQueryData(s);
  return r && t.setQueryData(
    s,
    r.filter((a) => a.id !== c)
  ), { previousInstructors: r };
};
export {
  i as addCourseInstructorOptimistically,
  n as removeCourseInstructorOptimistically
};
